import {createSlice} from '@reduxjs/toolkit';

const initialState = {}


const wizardSlice = createSlice({
    name: 'wizard',
    initialState,
    reducers: {
        setData: (state, action) => {
            Object.assign(state, action.payload);
        },
        clearData: (state) => {
            // eslint-disable-next-line no-unused-vars
            state = null;
        }

    },
});


export const {setData, clearData} = wizardSlice.actions;

export default wizardSlice.reducer;